import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../routes/authContext';
import { checkAccess, PATH_PRIVILEGES } from '../helpers/privilegeHelper';


const PrivilegeRoutes = () => {
  const location = useLocation();
  const { user } = useAuth();
  const hasAccess = checkAccess(user, location.pathname, PATH_PRIVILEGES);

  if (!hasAccess) {
    return <Navigate to="/unauthorized-access" replace />;
  }

  return <Outlet />;
};

export default PrivilegeRoutes;